// eslint-disable-next-line
import { organizationVendorFilterDto, queryFilterByOrg, vendorFilterDto, vendorQueryFilterByOrg, updateOrgVendorDetailPayload } from 'utils/proptypes';
import { AxiosResponse } from 'axios';
import base from './baseApi';
import { omitBy } from 'lodash';
import { createSearchParams } from 'react-router-dom';

const { urls, methods, execute } = base();
const getOrgVendorsByFilter = (queryFilter: vendorQueryFilterByOrg): Promise<AxiosResponse<organizationVendorFilterDto>> => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.vendors.vendors}/?${params.toString()}`;
  const response = execute(method, url, { authorization: true }) as Promise<AxiosResponse<organizationVendorFilterDto>>;

  return response;
};

const getOrgVendors = (): Promise<AxiosResponse<organizationVendorFilterDto>> => {
  const method = methods.GET;
  const url = `${urls.vendors.vendors}?limit=0`;
  const response = execute(method, url, { authorization: true }) as Promise<AxiosResponse<organizationVendorFilterDto>>;

  return response;
};

const getOrgVendorById = (id: string) => {
  const method = methods.GET;
  const url = `${urls.vendors.vendors}/${id}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const createMasterVendor = (payload: any) => {
  const method = methods.POST;
  const url = `${urls.vendors.vendors}`;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

const updateMasterVendorById = (id: any, payload: any) => {
  const method = methods.PUT;
  const url = `${urls.vendors.vendors}/${id}`;

  // do not include items in vendor update
  delete payload?.items

  const response = execute(method, url, { authorization: true }, payload);
  return response;
};

const deleteMasterVendorById = (id: string) => {
    const method = methods.DELETE;
    const url = `${urls.vendors.vendors}/${id}`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };

const getMasterVendorsByFilter = (queryFilter: vendorQueryFilterByOrg): Promise<AxiosResponse<vendorFilterDto>> => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.vendors.vendors}/all?${params.toString()}`;
  const response = execute(method, url, { authorization: true }) as Promise<AxiosResponse<vendorFilterDto>>;

  return response;
};

const getMasterVendors = (): Promise<AxiosResponse<vendorFilterDto>> => {
  const method = methods.GET;
  const url = `${urls.vendors.vendors}/all?limit=0`;
  const response = execute(method, url, { authorization: true }) as Promise<AxiosResponse<vendorFilterDto>>;

  return response;
};

const assignVendorToOrg = (payload: any) => {
  const method = methods.POST;
  const url = `${urls.vendors.vendors}/assign`;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

const unassignVendor = (organizationVendorId: string) => {
  const method = methods.DELETE;
  const url = `${urls.vendors.vendors}/assign/${organizationVendorId}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getVendorAssignments = (queryFilter: queryFilterByOrg) => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.vendors.vendors}/assign?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getOrganizationVendorAssignments = (queryFilter: vendorQueryFilterByOrg): Promise<AxiosResponse<organizationVendorFilterDto>> => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '' || v === undefined || v === null);
  const params = createSearchParams(initParams);

  const url = `${urls.vendors.vendors}/assignments?${params.toString()}`;
  const response = execute(method, url, { authorization: true }) as Promise<AxiosResponse<organizationVendorFilterDto>>;

  return response;
};

const updateOrgVendorDetail = (id: string, payload: updateOrgVendorDetailPayload) => {
  const method = methods.PUT;
  const url = `${urls.vendors.vendors}/${id}/organization-detail`;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

export {
    getOrgVendorsByFilter,
    getOrgVendors,
    getOrgVendorById,
    createMasterVendor,
    updateMasterVendorById,
    deleteMasterVendorById,
    getMasterVendorsByFilter,
    getMasterVendors,
    assignVendorToOrg,
    unassignVendor,
    getVendorAssignments,
    getOrganizationVendorAssignments,
    updateOrgVendorDetail
};
